'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports["default"] = StepThree;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Table = require('../../Table');

var _Table2 = _interopRequireDefault(_Table);

var _Column = require('../../Column');

var _Column2 = _interopRequireDefault(_Column);

var _getAssignFieldsData = require('../helpers/getAssignFieldsData');

var _getAssignFieldsData2 = _interopRequireDefault(_getAssignFieldsData);

var _modifyCell = require('./modifyCell');

var _modifyCell2 = _interopRequireDefault(_modifyCell);

var _fileFieldCell = require('./fileFieldCell');

var _fileFieldCell2 = _interopRequireDefault(_fileFieldCell);

var _databaseFieldCell = require('./databaseFieldCell');

var _databaseFieldCell2 = _interopRequireDefault(_databaseFieldCell);

var _assignFieldModal = require('./assignFieldModal');

var _assignFieldModal2 = _interopRequireDefault(_assignFieldModal);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function StepThree(props) {
  var attributes = props.attributes,
      columns = props.columns,
      onAssignField = props.onAssignField,
      fieldsMap = props.fieldsMap,
      data = props.data,
      matchField = props.matchField;
  var previewData = data.slice(0, 3);

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      assignData = _useState2[0],
      setAssignData = _useState2[1];

  (0, _react.useEffect)(function () {
    setAssignData((0, _getAssignFieldsData2["default"])({
      fieldsMap: fieldsMap,
      attributes: attributes,
      matchField: matchField
    }));
  }, [fieldsMap, attributes, matchField]);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isAssignFieldModalOpen = _useState4[0],
      setAssignFieldModalState = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      databaseFieldToAssign = _useState6[0],
      setDatabaseFieldToAssign = _useState6[1];

  var openAssignFieldModal = function openAssignFieldModal(field) {
    setAssignFieldModalState(true);
    setDatabaseFieldToAssign(field);
  };

  var closeAssignFieldModal = function closeAssignFieldModal() {
    setAssignFieldModalState(false);
  };

  return _react2["default"].createElement('div', null, _react2["default"].createElement(_Table2["default"], {
    className: 'rainbow-import-records-flow_table',
    keyField: 'id',
    data: assignData
  }, _react2["default"].createElement(_Column2["default"], {
    header: 'Modify',
    field: 'fileField',
    component: function component(rowProps) {
      return _react2["default"].createElement(_modifyCell2["default"], _extends({}, rowProps, {
        onClick: openAssignFieldModal
      }));
    }
  }), _react2["default"].createElement(_Column2["default"], {
    header: 'CSV titles',
    field: 'fileField',
    component: _fileFieldCell2["default"]
  }), _react2["default"].createElement(_Column2["default"], {
    header: 'Database fields',
    field: 'databaseField',
    component: _databaseFieldCell2["default"]
  })), _react2["default"].createElement(_assignFieldModal2["default"], {
    attributes: attributes,
    isAssignFieldModalOpen: isAssignFieldModalOpen,
    onRequestClose: closeAssignFieldModal,
    columns: columns,
    databaseFieldToAssign: databaseFieldToAssign,
    onAssignField: onAssignField,
    fieldsMap: fieldsMap,
    data: previewData
  }));
}

StepThree.propTypes = {
  onAssignField: _propTypes2["default"].func,
  fieldsMap: _propTypes2["default"].object,
  data: _propTypes2["default"].array,
  attributes: _propTypes2["default"].object
};
StepThree.defaultProps = {
  onAssignField: function onAssignField() {},
  fieldsMap: {},
  data: [],
  attributes: {}
};